const getDowntimeFlyup = (store) => {
  return store.downtimeFlyup;
};

export { getDowntimeFlyup };
